class GlobalEventListenerService {

    listeners: {[eventName: string]: Array<((eventArgs: any) => void)>} = {};

    public registerListener(eventName: string, cb: (eventArgs: any) => void) {
        if (this.listeners[eventName]) {
            this.listeners[eventName].push(cb);
        } else {
            this.listeners[eventName] = [cb];
        }
    }

    public detachListener(eventName: string, cb: (eventArgs: any) => void) {
        const eventListenerCBs = this.listeners[eventName];
        if (eventListenerCBs) {
            const listenerIndex = eventListenerCBs.indexOf(cb);
            if (listenerIndex >= 0) {
                eventListenerCBs.splice(listenerIndex, 1);
            }
        }
    }

    public notifyListener(eventName: string, eventArgs: any) {
        const eventListeners = this.listeners[eventName];
        if (eventListeners) {
            for (const eventListenerCB of eventListeners) {
                eventListenerCB(eventArgs);
            }
        }
    }

}

const GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE = new GlobalEventListenerService();

export {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE};
